import { LegEventScreen } from '@felix/ui';
import { useTranslation } from 'react-i18next';
import { Shell } from '../components/Shell.js';
import { officeVoyageSource } from '../voyage-source.js';

/** Leg / Event (ortak ekran; ADR 0022). Ofiste salt okunur: olaylar gemide girilir. */
export function LegEventPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('voyage.event.title')}>
      <LegEventScreen source={officeVoyageSource} />
    </Shell>
  );
}
